/*
 * @Description: 定向选择组件
 * @Author: yanzhigen@batmobi.net
 * @Date: 2018-09-17 15:53:13
 * @LastEditors: yanzhigen@batmobi.net
 * @LastEditTime: 2018-11-13 15:06:12
 */
<template>
    <div class="c-direct">
        <!-- 头部 已选标签组 -->
        <div class="direct-header">
            <div class="direct-tag-group">
                <Button v-for="(item,index) in selectedArr"
                        :key="item[code]"
                        size="small"
                        :type="btnType"
                        class="selected-item">
                    <span>{{item[tagName]}}</span>
                    <span @click="remove(index)"><Icon type="close-round"></Icon></span>
                </Button>
                <span class="no-data" v-if="!selectedArr.length">请选择一个或多个要定向的{{label}}</span>
            </div>
            <div class="direct-function">
                <span>共选择{{selectedArr.length}}项</span>
                <div>
                    <span class="btn-blue" v-clipboard:copy="value" v-clipboard:success="onCopySuccess">复制</span>
                    <span @click="$emit('input','')" class="btn-blue" style="margin-left:0.1rem">清空</span>
                </div>
            </div>
        </div>

        <!-- 主体 -->
        <Dropdown v-if="type==0" class="c-dropdown" trigger="click">
            <div class="direct-body">
                <input v-model.trim="keyword" placeholder="请选择" class="search" />
                <Icon class="search-icon" type="search"></Icon>
                <Button @click.stop="show.import=true" class="btn-import" type="primary">导入</Button>
            </div>
            <DropdownMenu slot="list" class="dropdown">
                <div v-for="item in filterList" :key="item[code]" class="dropdown-item" @click="select(item)">
                    <p class="dropdown-item-left showregular">
                        <span>{{item[left]}}</span>
                        <span>{{item[right]}}</span>
                    </p>
                    <div class="dropdown-item-right">
                        <i class="icon icon-checkbox" :class="{active:codeArr.includes(item[code])}"></i>
                    </div>
                </div>
                <div v-if="!filterList.length" class="dropdown-item" style="justify-content: center;">
                    No Data
                </div>
            </DropdownMenu>
        </Dropdown>

        <!-- 导入 -->
        <div v-if="show.import || type == 1" class="direct-footer">
            <textarea v-model="importText" class="import-text" rows="3" placeholder="请输入内容，区分大小写，以半角逗号隔开或者换行符隔开"></textarea>
            <Button v-if="type!=1" @click="show.import=false" class="btn-import" type="text">取消</Button>
            <Button @click="saveImport" class="btn-import" type="primary">保存</Button>
        </div>
    </div>
</template>
<script>
export default {
    name: 'cDirect',
    props: {
        value: {
            type: String,
            default: '',
        },
        label: {
            type: String,
            default: '选项',
        },
        btnType: {
            type: String,
            default: 'info',
        },
        list: {
            type: Array,
            default: () => [],
        },
        code: {
            type: String,
            default: '',
        },
        left: {
            type: String,
            default: '',
        },
        right: {
            type: String,
            default: '',
        },
        tagName: {
            type: String,
            default: '',
        },
        type: {
            type: String,
            default: '0',
        },
        searchLeftOnly: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            show: {
                import: false,
            },
            keyword: '', //关键字
            importText: '', //导入文本
        };
    },
    computed: {
        filterList() {
            const keyword = this.keyword.toUpperCase().trim();
            return this.list
                .filter(item => {
                    let bool = false;
                    bool = `${item[this.left]}`.toUpperCase().includes(keyword);
                    if (!this.searchLeftOnly) bool = bool || `${item[this.right]}`.toUpperCase().includes(keyword);
                    return bool;
                })
                .filter((item, index) => index < 50);
        },
        selectedArr() {
            const arr = this.value && this.value.split(',');
            return this.list.filter(item => arr && arr.includes(`${item[this.code]}`));
        },
        codeArr() {
            return this.selectedArr.map(item => item[this.code]);
        },
    },
    mounted() {
        if (this.type == 1) this.show.import = true;
    },
    methods: {
        /**
         * @desc 移除标签
         * @param {Number} index 索引
         */
        remove(index) {
            let arr = [...this.selectedArr];
            arr.splice(index, 1);
            this.$emit('input', arr.map(item => item[this.code]).join(','));
        },
        /**
         * @desc 选择选项
         * @param {Object} target 点击的目标
         */
        select(target) {
            if (this.selectedArr.every(item => item[this.code] != target[this.code])) {
                let arr = [...this.selectedArr];
                arr.push(target);
                this.$emit('input', arr.map(item => item[this.code]).join(','));
            } else {
                let arr = [...this.selectedArr.filter(item => item[this.code] != target[this.code])];
                this.$emit('input', arr.map(item => item[this.code]).join(','));
            }
        },
        /**
         * @desc 选择选项
         * @param {Object} target 点击的目标
         */
        saveImport() {
            if (this.importText == '') return;
            let arr1 = this.importText.split(','),
                arr2 = this.importText.split('\n'),
                arr = arr1.length >= arr2.length ? arr1 : arr2;
            //x：过滤的item数

            let warningFlag = false;

            //去除有误数据
            arr = arr.filter(item => item);
            let x = arr.length;
            arr = arr.filter(item => {
                let bool = this.list.some(cell => `${cell[this.code]}` == item);
                if (!bool) warningFlag = true;
                return bool;
            });

            let oldLength = arr.length + this.selectedArr.length;
            //去重
            arr = [...new Set([...this.selectedArr.map(item => `${item[this.code]}`), ...arr])];
            //有重复
            if (oldLength != arr.length) warningFlag = true;
            //记录过滤数x
            x -= arr.length - this.selectedArr.length;

            this.$emit('input', arr.join(','));

            //提示过滤信息
            if (warningFlag) this.$Message.warning({ content: `存在${x}条无法识别的或重复的数据，已去除` });
            else this.$Message.success({ content: '导入成功' });
        },
        /**
         * @desc 复制成功
         */
        onCopySuccess() {
            this.$Message.success({ content: '复制成功', duration: 1.5 });
        },
    },
};
</script>
<style lang="scss">
$border: 1px solid #e9e9e9;

.c-direct {
    margin-top: 0.1rem;
    width: 3.8rem;
    border-bottom: $border;
    .ivu-btn-small {
        padding: 0;
        font-size: 0.12rem;
        width: 0.44rem;
        height: 0.22rem;
    }
    .c-dropdown {
        width: 3.8rem;
        .dropdown {
            max-height: 3rem;
            min-height: 3rem;
            width: 3.8rem;
            overflow: auto;
            .dropdown-item {
                display: flex;
                line-height: 0.36rem;
                padding: 0 0.1rem;
                justify-content: space-between;
                align-items: center;
                &:hover {
                    background: #f3f3f3;
                }
                .dropdown-item-left {
                    flex: 1 1 auto;
                    display: flex;
                    justify-content: space-between;
                }
                .dropdown-item-right {
                    flex: 0 0 0.4rem;
                    display: flex;
                    justify-content: flex-end;
                }
            }
        }
    }
    .direct {
        &-header {
            min-height: 0.8rem;
            box-sizing: border-box;
            border: $border;
            border-bottom: none;
        }
        &-body {
            display: flex;
            border: $border;
            border-bottom: none;
            height: 0.36rem;
            width: 3.8rem;
            .search {
                flex: 1 1 auto;
                font-size: 0.14rem;
                padding: 0 0.1rem;
            }
            .search-icon {
                height: 0.36rem;
                line-height: 0.36rem;
                font-size: 0.22rem;
                margin: 0 0.1rem;
            }
            .btn-import {
                border-radius: 0;
            }
        }
        &-footer {
            border: $border;
            border-bottom: none;
            padding: 0.1rem;
            text-align: right;
            .import-text {
                border: 0;
                width: 100%;
                font-size: 0.14rem;
                resize: none;
            }
        }
    }
    // 已选择的标签
    .direct-tag-group {
        height: 0.74rem;
        overflow: auto;
        display: flex;
        flex-wrap: wrap;
        padding: 0.1rem 0.1rem 0 0.1rem;
        .selected-item {
            margin-right: 0.1rem;
            margin-bottom: 0.1rem;
            width: auto;
            padding: 0 0.05rem;
        }
    }

    .direct-function {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin: 0 0.1rem;
        line-height: 0.36rem;
        font-size: 0.14rem;
        border-top: $border;
    }
    .no-data {
        width: 100%;
        height: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
        position: relative;
        top: -0.1rem;
    }
}
</style>



// WEBPACK FOOTER //
// src/components/commons/cDirect.vue